import React from 'react';
import Image from 'next/image';
import ConfigContext from 'src/context/config';
import useNonNullContext from 'src/hooks/useNonNullContext';
import { Link } from '@mui/material';
const Logo: React.FC = () => {
  const configContext = useNonNullContext(ConfigContext);
  const { logoImgUrl, logoLinkUrl } = configContext.navBar;

  return (
    <Link href={logoLinkUrl} sx={{ display: 'flex', alignItems: 'center' }}>
      <Image
        src={logoImgUrl}
        alt="Logo"
        height={35}
        width={110}
        style={{ objectFit: 'contain' }}
      />
    </Link>
  );
};

export default Logo;
